import type { UserPreferencesNotificationsDropdownProps } from "./user-preferences-notifications-dropdown.type";
import type { MenuProps } from "antd";

import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";

import { getMenuItemActionOptions } from "./user-preferences-notifications-dropdown.helper";

export const UserPreferencesNotificationsDropdown = ({
  menuItems,
  onMenuItemClick,
  placement,
  ...buttonProps
}: UserPreferencesNotificationsDropdownProps) => {
  const onClick: MenuProps["onClick"] = (menuInfo) => {
    const options = getMenuItemActionOptions(menuInfo.itemData);
    if (!options) return;
    onMenuItemClick?.(options);
  };

  return (
    <Dropdown
      menu={{ items: menuItems, onClick }}
      placement={placement ?? "bottomRight"}
    >
      <Button icon={<MoreOutlined />} {...buttonProps} />
    </Dropdown>
  );
};
